import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function KioskJoin() {
    const navigate = useNavigate();
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);
    const join = async () => {
        setBusy(true);
        setErr(null);
        try {
            // Accept tail of tab id (last 6 chars) — match against open tabs
            const trimmed = code.trim().toUpperCase();
            const r = await fetch(`/api/tabs/TAB-${trimmed.replace(/^TAB-/i, "")}`).catch(() => null);
            // Fallback: try to scan the suffix
            let tabId = null;
            if (r && r.ok) {
                const j = await r.json();
                if (j?.tab?.id)
                    tabId = j.tab.id;
            }
            if (!tabId) {
                // Try server tables to map a table label
                const tbls = await fetch("/api/tables/" + trimmed + "/open_tab").catch(() => null);
                if (tbls && tbls.ok) {
                    const j = await tbls.json();
                    if (j?.tab_id)
                        tabId = j.tab_id;
                }
            }
            if (!tabId)
                throw new Error("Cuenta no encontrada");
            // Take them to the kiosk menu in "join" mode (tab_id in URL/query)
            navigate(`/kiosk/menu?tab=${encodeURIComponent(tabId)}`);
        }
        catch (e) {
            setErr(e.message);
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("div", { className: "grain min-h-screen bg-paper flex flex-col items-center justify-center p-8 text-center", children: [_jsx("p", { className: "font-mono text-xs tracking-[0.4em] text-mezcal uppercase", children: "\u2014 \u00DAnete a una cuenta \u2014" }), _jsx("h1", { className: "font-display font-black text-5xl tracking-kerned leading-tight mt-2", children: "Ya tienes mesa" }), _jsx("p", { className: "font-sans text-ink/70 mt-3 max-w-md", children: "Ingresa los \u00FAltimos 6 caracteres del recibo, o el n\u00FAmero de mesa." }), _jsx("input", { autoFocus: true, value: code, onChange: (e) => setCode(e.target.value.toUpperCase()), onKeyDown: (e) => e.key === "Enter" && join(), placeholder: "ej. M3 o A1B2C3", className: "mt-6 w-full max-w-xs px-4 py-4 text-center text-2xl font-mono tracking-widest bg-paper border-2 border-ink/15 rounded" }), err && _jsx("div", { className: "mt-3 text-hibisco font-mono text-sm", children: err }), _jsxs("div", { className: "mt-6 flex gap-3", children: [_jsx("button", { onClick: () => navigate("/kiosk"), className: "px-6 py-3 rounded-sm border-2 border-ink/30", children: "Atr\u00E1s" }), _jsx("button", { onClick: join, disabled: busy || code.length < 2, className: "px-6 py-3 rounded-sm bg-mezcal text-paper disabled:opacity-30 font-display font-bold", children: busy ? "…" : "Unirme" })] }), _jsx("button", { onClick: () => navigate("/kiosk/menu"), className: "mt-8 text-sm underline text-ink/60", children: "No, solo quiero ordenar \u2192" })] }));
}
